/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import ReactQuill from "react-quill-new";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import InputField from "components/fields/InputField";
import Card from "components/card";
import { getCms, updateCms } from "api/services/cmsServices";

const PrivacyPolicy = () => {
  const [formData, setformData] = useState({
    title: "",
    description: "",
    img: "",
    imgPreview: "",
  });
  const [error, setError] = useState("");

  useEffect(() => {
    getData();
  }, []);

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ script: "sub" }, { script: "super" }],
      [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ direction: "rtl" }],
      [{ align: [] }],
      ["blockquote", "code-block"],
      ["link", "image", "video", "formula"],
      ["clean"],
    ],
  };

  const getData = async () => {
    let response = await getCms("privacy");
    // console.log(response?.data?.data);
    if (response.status == 200) {
      setformData({
        ...formData,
        description: response?.data?.data?.description,
        title: response?.data?.data?.title,
        imgPreview: response?.data?.data?.image || ""
      });
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!formData.title.trim()) {
      newErrors.title = "Title is required";
    }
    if (!formData.description.trim() || formData.description == "<p><br></p>") {
      newErrors.description = "Description is required";
    }
    // if (!formData.img) {
    //   newErrors.img = "Image is required";
    // }

    if (Object.keys(newErrors).length > 0) {
      setError(newErrors);
      return;
    }
    let fd = new FormData();
    fd.append("title", formData?.title);
    fd.append("description", formData?.description);
    fd.append("type", "privacy");
    // fd.append("image", formData?.img)

    try {
      let response = await updateCms(fd);

      if (response?.status == 200) {
        toast.success("Privacy policy updated successfully");
      } else {
        toast.error("Failed to update privacy policy");
      }
    } catch (error) {
      toast.error(error.response?.data?.error || "Something went wrong");
    }

    // console.log("Form submitted:", formData?.img);
  };

  return (
    <div className="mt-5">
      <Card extra={"w-full h-full sm:overflow-auto p-6"}>
        <form>
          <InputField
            label="Title*"
            placeholder="Enter Title"
            id="title"
            type="text"
            value={formData?.title}
            onChangeFun={(e) => {
              setformData({ ...formData, title: e.target.value });
              setError({ ...error, title: "" });
            }}
          />
          {error.title && (
            <p className="mb-2 ml-2 text-sm text-red-500">{error.title}</p>
          )}

          <div className="mt-4 h-[600px] lg:h-[430px]">
            <label
              className={`text-sm font-bold text-navy-700 dark:text-white`}
            >
              description*
            </label>
            <ReactQuill
              theme="snow"
              value={formData?.description}
              onChange={(value) => {
                setformData({ ...formData, description: value });
                setError((prev) => ({ ...prev, description: "" }));
              }}
              modules={modules}
              style={{ height: "360px", paddingTop: "10px" }}
            />
          </div>
          {error?.description && (
            <p className="mb-2 ml-2 text-sm text-red-500">
              {error.description}
            </p>
          )}

          {/* <div className="mt-6">
            <label className="text-sm font-bold text-navy-700 dark:text-white">
              Upload Image*
            </label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) {
                  const reader = new FileReader();
                  reader.onloadend = () => {
                    setformData({
                      ...formData,
                      img: file,
                      imgPreview: reader.result,
                    });
                    setError((prev) => ({ ...prev, img: "" }));
                  };
                  reader.readAsDataURL(file);
                }
              }}
              className="mt-2 block w-full text-sm text-gray-500 file:mr-4 file:rounded-md file:border-0 file:bg-blue-50 file:px-4 file:py-2 file:text-sm file:font-semibold file:text-blue-700 hover:file:bg-blue-100"
            />
            {error?.img && (
              <p className="mb-2 ml-2 text-sm text-red-500">{error.img}</p>
            )}

            {formData.imgPreview && (
              <img
                src={formData.imgPreview}
                alt="Preview"
                className="mt-4 h-40 rounded-lg border object-contain"
              />
            )}
          </div> */}

          <div className="flex justify-end mt-6">
            <button
              onClick={(e) => handleSave(e)}
              className="text-md rounded-md bg-brand-500 px-4 py-1.5 font-semibold text-white shadow transition hover:bg-brand-600"
            >
              Save
            </button>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default PrivacyPolicy;
